import { action } from "sky-engine/api/index";
import {
  SERVICE_PRICE_INVITE_CODE,
  SERVICE_PRICE_OP_AUDIT,
} from "@/api/apiModules";

// ==================== 邀请码管理 ====================

/**
 * 查询邀请码列表
 * @param {Object} params 分页参数
 */
export function listInviteCode(params) {
  return action(SERVICE_PRICE_INVITE_CODE, "list", params);
}

/**
 * 创建邀请码
 * @param {Object} params { expireHours: number }
 */
export function createInviteCode(params) {
  return action(SERVICE_PRICE_INVITE_CODE, "create", params);
}

/**
 * 删除邀请码
 * @param {Object} params { id: string }
 */
export function deleteInviteCode(params) {
  return action(SERVICE_PRICE_INVITE_CODE, "delete", params);
}

/**
 * 验证邀请码
 * @param {Object} params { inviteCode: string }
 */
export function validateInviteCode(params) {
  return action(SERVICE_PRICE_INVITE_CODE, "validate", params);
}

// ==================== 操作审计 ====================

/**
 * 查询指定邀请码的审计记录列表
 * @param {Object} params 分页参数（含inviteCode条件）
 */
export function listOpAudit(params) {
  return action(SERVICE_PRICE_OP_AUDIT, "list", params);
}

/**
 * 查询审计记录详情（含完整content数据）
 * @param {Object} params { id: string }
 */
export function detailOpAudit(params) {
  return action(SERVICE_PRICE_OP_AUDIT, "detail", params);
}

/**
 * 创建审计记录（明细数据变化时调用）
 * @param {Object} params { inviteCode: string, content: string }
 */
export function createOpAudit(params) {
  return action(SERVICE_PRICE_OP_AUDIT, "create", params);
}
